import React from 'react';
import { FIELD_DETAILS_BY_FIELD_TYPE } from 'src/views/constants/fieldConstants';
import { FieldType } from 'src/types';

interface Props {
  item: Record<any, any>,
  attribute: string,
  type: FieldType,
  isFake?: boolean,
}

const ColumnRenderer = ({
  item,
  attribute,
  type,
  isFake
}: Props) => {
  const Component = FIELD_DETAILS_BY_FIELD_TYPE[type].columnRenderer;

  let value = item;

  if (isFake) {
    // fake data has no nested fields
    value = value[attribute];
  } else {
    // access nested fields
    attribute.split('.').forEach((attr: any) => {
      value = value[attr];
    });
  }

  return <Component value={value} />;
};

export default ColumnRenderer;
